module.exports = __webpack_public_path__ + "img/alarm.71794f71.svg";